<app-loading-spinner *ngIf="spinner"></app-loading-spinner>
<div class="app-container" style="display:flex; flex-direction:column;">
  <app-header *ngIf="isNotFoundRoute()" [menus]="menus" [isAdmin]="isAdmin" [loggedUser]="loggedUser" [showImage]="showImage" class="sticky-header"></app-header>
  <div [ngClass]="getClassForRoute(currentRoute)" class="container contentwidth mt-5" style="flex-grow:1">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="isNotFoundRoute()"></app-footer>
</div>
